import { render, staticRenderFns } from "./new-login.vue?vue&type=template&id=902342a0&"
import script from "./new-login.vue?vue&type=script&lang=js&"
export * from "./new-login.vue?vue&type=script&lang=js&"
import style0 from "./new-login.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports